import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ArrayField as ArrayField$1 } from '../ArrayField.js';
import { FormComponents } from '../FormComponents.js';
import { FormFields } from '../FormFields.js';

var _excluded = ["name", "items", "uiBefore", "uiAfter"];
var ArrayField = function ArrayField(_ref) {
  var name = _ref.name,
    items = _ref.items,
    uiBefore = _ref.uiBefore,
    uiAfter = _ref.uiAfter,
    props = _objectWithoutProperties(_ref, _excluded);
  // const ArrayField = ({ name, items, ...props }) => {
  // const { 'ui:props': uiProps = {} } = items;
  return /*#__PURE__*/React.createElement(ArrayField$1, _extends({
    name: name
  }, props), /*#__PURE__*/React.createElement(FormComponents, {
    components: uiBefore
  }), /*#__PURE__*/React.createElement(ArrayField$1.Items, null, function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormFields, {
      schema: items
    }));
  }), /*#__PURE__*/React.createElement(FormComponents, {
    components: uiAfter
  }));
};

export { ArrayField };
